import { Injectable } from '@angular/core';

import { ERoleActions } from '@enums';
import { IBitfUiRoleManagerService } from '@interfaces';
import { StoreService } from '@services';

@Injectable({
  providedIn: 'root',
})
export class UiRoleManagerService implements IBitfUiRoleManagerService {
  constructor(private storeService: StoreService) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canI(action: ERoleActions, data?: any): boolean {
    switch (action) {
      case ERoleActions.VIEW_LOG:
        return this.storeService.store.user.canViewLogs;
      case ERoleActions.VIEW_ADMIN:
        return this.storeService.store?.user.canViewAdmin;
      case ERoleActions.VIEW_ADMIN_BOOKLETS:
        return this.storeService.store?.user.canViewAdminBooklets;
      case ERoleActions.VIEW_ADMIN_DASHBOARD:
        return this.storeService.store?.user.canViewAdminDashboard;
      case ERoleActions.VIEW_ADMIN_ACCOUNTING:
        return this.storeService.store?.user.canViewAdminAccounting;
      case ERoleActions.VIEW_ADMIN_PARTNERS:
        return this.storeService.store?.user.canViewAdminPartners;

      case ERoleActions.CAN_CREATE_ADMIN_BOOKLETS:
        return this.storeService.store?.user.canCreateAdminBooklets;
      case ERoleActions.CAN_DELETE_ADMIN_BOOKLETS:
        return this.storeService.store?.user.canDeleteAdminBooklets;
      case ERoleActions.CAN_FILTER_ADMIN_BOOKLETS_BY_GROUP_AND_AGENCY:
        return this.storeService.store?.user.canFilterAdminBookletsByGroupAndAgency;
      case ERoleActions.CAN_EDIT_ADMIN_FILE_SETTINGS:
        return (
          this.storeService.store?.user.canViewAdminBooklets &&
          (!this.storeService.store?.user.isSurveyor ||
            (this.storeService.store?.user.isSurveyor && ['note', 'compliant'].includes(data?.fieldName)))
        );
      case ERoleActions.CAN_VIEW_STRAPI_LINK:
        return this.storeService.store?.user.canViewStrapiLink;
      case ERoleActions.CAN_VIEW_CASADOC_CALENDAR:
        return this.storeService.store?.user.canViewCasadocCalendar;
      case ERoleActions.CAN_VIEW_SURVEYOR_ASSIGNMENTS:
        return this.storeService.store?.user.canViewSurveyorAssignments;
      case ERoleActions.VIEW_ADMIN_NEWSLETTER:
        return this.storeService.store?.user.canViewAdminNewsletter;
      default:
        return false;
    }
  }
}
